module.exports = __webpack_public_path__ + "static/media/ClearText.412b9f41.svg";